module.exports = __webpack_public_path__ + "img-dashboard/register/pencil-white.d28f5bd3.png";